var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 5c1.333 0 2.333 1.083 2.417 2.417 0 1.333-1 2.5-2.417 2.5A2.418 2.418 0 017.583 7.5C7.583 6.167 8.667 5 10 5zm4 10H6c-.083 0-.167-.083-.167-.25a4.23 4.23 0 011.25-3c.834-.833 1.834-1.25 3-1.25a4.23 4.23 0 013 1.25c.834.75 1.25 1.833 1.25 3-.083.167-.166.25-.333.25z",
    fill: "currentColor"
  })));
}
export default SvgIconUserCircle;